import * as React from 'react';
export const goldenoneSvg = React.forwardRef(function goldenoneSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFBC2B',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M21.2 23.35c-.55 0-1.23-.11-1.23-.72 0-.96 1.75-.73 1.96-1.65.17-.69.17-1.41.17-2.06v-3.94c0-1.34-.34-1.53-1.79-1.57-.46 0-.97-.19-.97-.69 0-.42.46-.72.8-.91l4.3-2.07c.21-.11.47-.23.73-.23.55 0 .63.62.63 1.04v9.82c0 .65.09 1.15.85 1.38.43.11.98.23 1.03.72 0 .61-.6.84-1.2.84h-5.27v.04zm-7.12 0c-2.25 0-4.73-.22-6.68-1.35a6.14 6.14 0 0 1-3.08-5.37c0-4.12 4.14-6.78 7.98-6.78.89 0 1.9.23 2.78.23.41 0 .53-.57 1-.57.42 0 .66.4.77.74l1.19 2.77c.05.16.11.33.11.56 0 .28-.17.5-.47.5-.65 0-2.54-2.36-5.14-2.36-2.72 0-4.2 2.26-4.2 4.74 0 2.88 2.01 5.03 4.97 5.03 1.42 0 1.6-.62 1.6-1.58v-.96c0-1.47-1.13-.74-1.13-1.7 0-.68.6-.73 1.12-.73h3.2c.53 0 1.12 0 1.18.67 0 .4-.18.63-.6.74-.53.11-.53.56-.53 1.07v1.81c0 .4 0 .9.42 1.07.3.12.77.23.77.68 0 .73-.6.73-1.19.73h-4.07v.06z',
      }),
    ),
  );
});
goldenoneSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var goldenone = {
  category: 'brand',
  colorable: false,
  name: 'goldenone',
  svg: goldenoneSvg,
};
